import { useQuery } from "@tanstack/react-query";
import { getPeerCohort } from "../api/peer-cohort-api.ts";
import type { CohortLens } from "../types/peer-cohort.ts";

const STALE_MS = 60 * 1000;

export function usePeerCohort(projectId: string | null | undefined, lens: CohortLens) {
  return useQuery({
    queryKey: ["intelligence", "peer-cohort", projectId, lens] as const,
    queryFn: () => {
      if (!projectId) throw new Error("projectId required");
      return getPeerCohort(projectId, lens);
    },
    enabled: Boolean(projectId),
    staleTime: STALE_MS,
  });
}
